const TOPICS = [
  { name: '暑期档', hot: true, count: '2.3万讨论' },
  { name: '动作大片', hot: true, count: '1.8万讨论' },
  { name: '爆笑喜剧', hot: false, count: '1.5万讨论' },
  { name: '科幻巨制', hot: true, count: '1.2万讨论' },
  { name: '国产新片', hot: false, count: '9860讨论' },
  { name: '港片经典', hot: false, count: '8750讨论' },
  { name: '悬疑烧脑', hot: true, count: '7620讨论' },
  { name: '高分佳作', hot: false, count: '6980讨论' },
  { name: '每日更新', hot: true, count: '1.1万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">影迷们正在热议的电影话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <a
              key={topic.name}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-full hover:border-primary-500/40 transition-all duration-200 cursor-pointer"
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-500/15">
                  <i className="ri-fire-line text-xs text-accent-500" />
                </span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}